// Supported image types that can be displayed in browser
const BROWSER_SUPPORTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
  "image/bmp",
];

/**
 * Check if the file can be displayed as an image in the browser
 */
export const canDisplayImageInBrowser = (file: File): boolean => {
  return BROWSER_SUPPORTED_IMAGE_TYPES.includes(file.type.toLowerCase());
};

/**
 * Get file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  const parts = filename.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
};

/**
 * Check if file is an unsupported image format (like HEIC)
 */
export const isUnsupportedImageFormat = (file: File): boolean => {
  const extension = getFileExtension(file.name);
  const unsupportedExtensions = ["heic", "heif"];

  return (
    unsupportedExtensions.includes(extension) ||
    (file.type.startsWith("image/") && !canDisplayImageInBrowser(file))
  );
};
